import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LOCAL_STORAGE_KEY } from '@core/configs';
import { AuthService } from '@core/services/apis';
import { LocalStorageService, MultipleSpinnerService } from '@core/services/common';
import { environment } from '@environments/environment';
import { Subscription } from 'rxjs';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { PivotConfirmDialogComponent } from '../pivot-confirm-dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pivot-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent  implements OnInit, OnDestroy {
  trigger: CdkOverlayOrigin;
  isLoggedIn = false;
  subscriptions: Subscription[] = [];
  fullName = '';
  timeoutMenu: any;
  isOpenOtherMenu = false;
  
  constructor(
    private multipleSpinnerService: MultipleSpinnerService,
    private localStorageService: LocalStorageService,
    private authService: AuthService,
    public dialog: MatDialog,
    private translate: TranslateService,
  ) {}
  
  ngOnInit(): void {
    const getIsLoggedIn = this.authService.getIsLoggedIn().subscribe((res) => {
      this.isLoggedIn = res;
      this.fullName = localStorage.getItem(LOCAL_STORAGE_KEY.fullName);
    });
    this.subscriptions.push(getIsLoggedIn);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  toggleSidebar(): boolean {
    return false;
  }

  onLogout(): void {
    this.dialog
    .open(PivotConfirmDialogComponent, {
      panelClass: ['custom-dialog-container', 'pivot-setting-confirm-dialog'],
      data: {
        message: this.translate.instant('LOGOUT.TITLE'),
        messageLeft: true,
        useInnerHTML: true,
        type: 1,
        isDisplayHeader: false,
      },
    })
    .afterClosed()
    .subscribe(res => {
      if (res) {
        this.authService.logout();
      }
    });
  }

  onLeave() {
    this.timeoutMenu = setTimeout(() => {
      this.isOpenOtherMenu = false;
    }, 300);
  }

  onHover() {
    clearTimeout(this.timeoutMenu);
    this.isOpenOtherMenu = true;
  }

  backdropClick() {
    this.isOpenOtherMenu = false;
  }

  goAccountInformation() {
    this.multipleSpinnerService.show();
    this.authService.verifyRefreshToken().subscribe(async (res) => {
        if (res?.result?.result) {
            window.open(environment.cKPassWebappUrl + 'account-information?accessToken='
                + this.localStorageService.getAccessToken() + '&refreshToken='
                + this.localStorageService.getRefreshToken());
        } else {
            await this.authService.logout();
        }
        this.multipleSpinnerService.hide();
    }, async () => {
        await this.authService.logout();
    });
  }

  navigateHome() {
    return false;
  }
}
